import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/app/store/authStore';
import { useRoute, useRouter } from 'vue-router/composables';
import { AuthorityType } from 'ah-api-gateways';
import { computed, ref } from 'vue';
import DownloadPartnerCommissionsStatementModal from 'ah-trades/src/components/modals/DownloadPartnerCommissionsStatementModal.vue';
import SearchableTradeReportList from 'ah-trades/src/components/lists/SearchableTradeReportList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityReportsAndAndStatementsView',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();

const openTrade = ref<string>();

const canSeeExport = computed(() => authStore.hasAuthorities(AuthorityType.EXPORT_PARTNER_COMMISSION_REPORTS));
const isActivityReports = computed(() => route.path.startsWith('/admin/activity/reports'));

if (route.query.trade) {
  const { trade, ...query } = route.query;
  router.replace({ path: route.path, query });
  openTrade.value = trade as string;
}

return { __sfc: true,authStore, router, route, openTrade, canSeeExport, isActivityReports, DownloadPartnerCommissionsStatementModal, SearchableTradeReportList }
}

})